import React from 'react';
import { useStore } from 'effector-react';
import { EditConfigLoadingType, ImageType } from '@types';
import { $GateConfigLoading } from '@stores/editingStores';
import useLangString from '@hooks/useLangString';
import Image from '@components/Image';
import { IconLoading } from '@components/IconLoading';

export function ConfigLoadingLayer() {
  const state = useStore($GateConfigLoading.state);

  const lang = useLangString({ loading: ['加载中', 'loading'] }, []);

  if (!state) return null;
  const { type, bgColor, itemColor, mediaUrl } = state;

  const renderCustom = () => {
    if (!mediaUrl) {
      return (
        <div className="flex h-50 w-50 flex-col items-center justify-center border border-blue bg-blue bg-opacity-50 text-sm">
          <p>未添加</p>
          <p>图片</p>
        </div>
      );
    }
    return <Image src={mediaUrl} type={ImageType.media} />;
  };

  return (
    <div
      className="absolute inset-0 flex items-center justify-center"
      style={{ backgroundColor: `rgba(${bgColor})` }}
    >
      {type === EditConfigLoadingType.system && (
        <IconLoading color={`rgba(${itemColor})`} size={50} />
      )}
      {type === EditConfigLoadingType.text && (
        <div className="text-sm" style={{ color: `rgba(${itemColor})` }}>
          {lang.loading}
        </div>
      )}
      {type === EditConfigLoadingType.custom && renderCustom()}
    </div>
  );
}
